module.exports = __webpack_public_path__ + "static/img/bg-es.8b5aa575.png";